import './application';

jQuery(function ($) {
  if (location.href.match('tab02')) {
    $(".tab_inner [class^='page1']").addClass("hide");
    $(".tab_inner [class^='page2']").removeClass("hide");
  } else {
    $(".tab_inner [class^='page1']").removeClass("hide");
    $(".tab_inner [class^='page2']").addClass("hide");
  }
});